import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';

// ==============================|| LOADER - CIRCULAR ||============================== //

interface IProgress {
  size?: string;
  color?: string;
}

const Loader = ({ size, color = '#5b31aa' }: IProgress) => {
  return (
    <Stack
      alignItems='center'
      justifyContent='center'
      sx={{ height: '100%' }}
    >
      <CircularProgress
        size={size}
        sx={{
          color,
        }}
      />
    </Stack>
  );
};

export default Loader;
